import { Box, OverflowMenu, MenuItem, useDialogControllers } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import DeleteMessageModal from './DeleteMessageModal'

type OverflowMenuAutoReplyProps = {
  status: string
  setStatus: () => void
  id: string
}

const OverflowMenuAutoReply = ({ status, setStatus, id }: OverflowMenuAutoReplyProps) => {
  const { t } = useTranslation()

  const { visible, showModal, closeModal } = useDialogControllers({
    deleteMessage: false
  })

  return (
    <>
      <Box justifyContent="center" marginLeft={'xsmall'}>
        <OverflowMenu label="Options" width="medium">
          <MenuItem
            onClick={() => {
              setStatus()
            }}
          >
            {status === '1'
              ? t('l.settings.view.auto_reply.set_as_inactive', 'Set as inactive')
              : t('l.settings.view.auto_reply.set_as_active', 'Set as active')}
          </MenuItem>
          <MenuItem onClick={showModal('deleteMessage')} tone="critical">
            {t('common.delete', 'Delete')}
          </MenuItem>
        </OverflowMenu>
      </Box>

      <DeleteMessageModal
        visible={visible.deleteMessage}
        closeModal={closeModal('deleteMessage')}
        contentID={id}
      />
    </>
  )
}

export default OverflowMenuAutoReply
